import React from 'react';
import { useNavigate } from 'react-router-dom';
import SwyperLogo from './SwypeRLogo';

const TopNav = () => {
  const navigate = useNavigate();

  return (
    <div className="fixed top-0 left-0 right-0 bg-white border-b border-gray-200 z-50">
      <div className="max-w-7xl mx-auto px-4 py-2">
        <div 
          className="flex justify-center cursor-pointer"
          onClick={() => navigate('/swipe')}
        >
          <SwyperLogo width={150} height={60} />
        </div>
      </div>
    </div>
  );
};

export default TopNav;
